var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"user-img"},[_c('img',{attrs:{"src":_vm.avatar?_vm.avatar:require('../../assets/img/qrcode_for_gh_9183a2f83e7b_1280(3).jpg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }